import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import VehicleDetails from './pages/VehicleDetails'
import Financing from './pages/Financing'
// import LeaseCalculatorPage from './pages/LeaseCalculatorPage'
import About from './pages/About'
import Contact from './pages/Contact'
import Policy from './pages/Policy'
import NotFound from './pages/NotFound'
import SignIn from './pages/SignIn'
import Register from './pages/Register'
import Account from './pages/Account'
import AccountOverview from './pages/account/AccountOverview'
import AccountBookings from './pages/account/AccountBookings'
import AccountInstalments from './pages/account/AccountInstalments'
import AccountCars from './pages/account/AccountCars'
import { RequireCustomer } from './components/account/RequireCustomer'
import ComingSoon from "./pages/ComingSoon"

/* The design-system page is a development tool, so it is lazily imported and
   only routed in dev — a production build never loads that chunk. */
const UiKit = lazy(() => import('./pages/UiKit'))

/* The filters travel with the redirect: a bookmarked /cars?brand=Toyota is a
   query somebody saved, and the section reads the same parameters the page
   did. */
function CarsRedirect() {
  const { search } = useLocation()
  return <Navigate to={{ pathname: '/home', search, hash: '#cars' }} replace />
}

function App() {
  return (
    <Routes>
        <Route index element={< ComingSoon/>} />
      <Route element={<Layout />}>

        <Route path="/home" element={<Home />} />
        {/* The listing is a section of the home page now, not a page of its
            own. The old address still answers so a link somebody was sent —
            or bookmarked with its filters on — lands where the cars are. */}
        <Route path="cars" element={<CarsRedirect />} />
        <Route path="cars/:id" element={<VehicleDetails />} />
        <Route path="financing" element={<Financing />} />
        {/* <Route path="lease-calculator" element={<LeaseCalculatorPage />} /> */}
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="policy" element={<Policy />} />

        {/* A buyer's own corner. The two doors are outside the guard — a
            signed-out visitor has to be able to reach them — and everything
            under /account is behind it.

            The guard is a courtesy: every request these pages make is
            answered about whoever the token says is asking, so no id here is
            editable into somebody else's records. What it buys is a password
            screen instead of four failed requests. */}
        <Route path="sign-in" element={<SignIn />} />
        <Route path="register" element={<Register />} />

        <Route element={<RequireCustomer />}>
          <Route path="account" element={<Account />}>
            <Route index element={<AccountOverview />} />
            <Route path="bookings" element={<AccountBookings />} />
            <Route path="instalments" element={<AccountInstalments />} />
            <Route path="cars" element={<AccountCars />} />
          </Route>
        </Route>
        {import.meta.env.DEV && (
          <Route
            path="ui-kit"
            element={
              <Suspense fallback={null}>
                <UiKit />
              </Suspense>
            }
          />
        )}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
